/* https://iendeavor.github.io/vue-next-select/#features */
import { app } from "@/main";
import VueNextSelect from "vue-next-select";
import "vue-next-select/dist/index.min.css";

app.component("vue-select", VueNextSelect);
